// extracted by mini-css-extract-plugin
export var aircallIframe = "_l7-3";
export var fabContainer = "_l7-5";
export var fabRinging = "_l7-6";
export var loadingOverlay = "_l7-4";
export var pulse = "_l7-7";
export var widgetContent = "_l7-2";
export var widgetPanel = "_l7-0";
export var widgetPanelExpanded = "_l7-1";